export const PRODUCT_TYPES = {
    TRADITIONAL_TERM: "traditional_term",
    EXPRESS_TERM: "express_term",
};
